import { render, staticRenderFns } from "./before-payment.vue?vue&type=template&id=2c9cfbee&scoped=true&"
import script from "./before-payment.vue?vue&type=script&lang=js&"
export * from "./before-payment.vue?vue&type=script&lang=js&"
import style0 from "./before-payment.vue?vue&type=style&index=0&id=2c9cfbee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9cfbee",
  null
  
)

export default component.exports